var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsConnected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32561_13218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9668 19.7379C16.9668 20.6419 17.3259 21.5088 17.9651 22.148C18.6043 22.7872 19.4712 23.1463 20.3751 23.1463C21.2791 23.1463 22.146 22.7872 22.7852 22.148C23.4244 21.5088 23.7835 20.6419 23.7835 19.7379C23.7835 18.834 23.4244 17.9671 22.7852 17.3279C22.146 16.6887 21.2791 16.3296 20.3751 16.3296C19.4712 16.3296 18.6043 16.6887 17.9651 17.3279C17.3259 17.9671 16.9668 18.834 16.9668 19.7379Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625 19.7379C1.625 20.6419 1.98409 21.5088 2.62328 22.148C3.26246 22.7872 4.12939 23.1463 5.03333 23.1463C5.93728 23.1463 6.8042 22.7872 7.44339 22.148C8.08258 21.5088 8.44167 20.6419 8.44167 19.7379C8.44167 18.834 8.08258 17.9671 7.44339 17.3279C6.8042 16.6887 5.93728 16.3296 5.03333 16.3296C4.12939 16.3296 3.26246 16.6887 2.62328 17.3279C1.98409 17.9671 1.625 18.834 1.625 19.7379Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9668 5.24793C16.9668 6.15188 17.3259 7.0188 17.9651 7.65799C18.6043 8.29718 19.4712 8.65627 20.3751 8.65627C21.2791 8.65627 22.146 8.29718 22.7852 7.65799C23.4244 7.0188 23.7835 6.15188 23.7835 5.24793C23.7835 4.34399 23.4244 3.47706 22.7852 2.83788C22.146 2.19869 21.2791 1.8396 20.3751 1.8396C19.4712 1.8396 18.6043 2.19869 17.9651 2.83788C17.3259 3.47706 16.9668 4.34399 16.9668 5.24793Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9668 35.9313C16.9668 36.8352 17.3259 37.7022 17.9651 38.3413C18.6043 38.9805 19.4712 39.3396 20.3751 39.3396C21.2791 39.3396 22.146 38.9805 22.7852 38.3413C23.4244 37.7022 23.7835 36.8352 23.7835 35.9313C23.7835 35.0273 23.4244 34.1604 22.7852 33.5212C22.146 32.882 21.2791 32.5229 20.3751 32.5229C19.4712 32.5229 18.6043 32.882 17.9651 33.5212C17.3259 34.1604 16.9668 35.0273 16.9668 35.9313Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3081 35.9313C32.3081 36.8352 32.6672 37.7022 33.3064 38.3413C33.9456 38.9805 34.8125 39.3396 35.7164 39.3396C36.6204 39.3396 37.4873 38.9805 38.1265 38.3413C38.7657 37.7022 39.1248 36.8352 39.1248 35.9313C39.1248 35.0273 38.7657 34.1604 38.1265 33.5212C37.4873 32.882 36.6204 32.5229 35.7164 32.5229C34.8125 32.5229 33.9456 32.882 33.3064 33.5212C32.6672 34.1604 32.3081 35.0273 32.3081 35.9313Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3081 19.7379C32.3081 20.6419 32.6672 21.5088 33.3064 22.148C33.9456 22.7872 34.8125 23.1463 35.7164 23.1463C36.6204 23.1463 37.4873 22.7872 38.1265 22.148C38.7657 21.5088 39.1248 20.6419 39.1248 19.7379C39.1248 18.834 38.7657 17.9671 38.1265 17.3279C37.4873 16.6887 36.6204 16.3296 35.7164 16.3296C34.8125 16.3296 33.9456 16.6887 33.3064 17.3279C32.6672 17.9671 32.3081 18.834 32.3081 19.7379Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625 5.24793C1.625 6.15188 1.98409 7.0188 2.62328 7.65799C3.26246 8.29718 4.12939 8.65627 5.03333 8.65627C5.93728 8.65627 6.8042 8.29718 7.44339 7.65799C8.08258 7.0188 8.44167 6.15188 8.44167 5.24793C8.44167 4.34399 8.08258 3.47706 7.44339 2.83788C6.8042 2.19869 5.93728 1.8396 5.03333 1.8396C4.12939 1.8396 3.26246 2.19869 2.62328 2.83788C1.98409 3.47706 1.625 4.34399 1.625 5.24793Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3081 5.24793C32.3081 6.15188 32.6672 7.0188 33.3064 7.65799C33.9456 8.29718 34.8125 8.65627 35.7164 8.65627C36.6204 8.65627 37.4873 8.29718 38.1265 7.65799C38.7657 7.0188 39.1248 6.15188 39.1248 5.24793C39.1248 4.34399 38.7657 3.47706 38.1265 2.83788C37.4873 2.19869 36.6204 1.8396 35.7164 1.8396C34.8125 1.8396 33.9456 2.19869 33.3064 2.83788C32.6672 3.47706 32.3081 4.34399 32.3081 5.24793Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.625 35.9313C1.625 36.8352 1.98409 37.7022 2.62328 38.3413C3.26246 38.9805 4.12939 39.3396 5.03333 39.3396C5.93728 39.3396 6.8042 38.9805 7.44339 38.3413C8.08258 37.7022 8.44167 36.8352 8.44167 35.9313C8.44167 35.0273 8.08258 34.1604 7.44339 33.5212C6.8042 32.882 5.93728 32.5229 5.03333 32.5229C4.12939 32.5229 3.26246 32.882 2.62328 33.5212C1.98409 34.1604 1.625 35.0273 1.625 35.9313Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37842 33.4562L18.0301 22.2129",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7168 8.65796V16.328",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7832 19.738H32.3065",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8535 17.3963L33.2368 7.5896",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51318 7.5896L17.8965 17.3963",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32561_13218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.375 0.5896)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsConnected);
export default __webpack_public_path__ + "static/media/dotsConnected.7659e7a365fbe7fc4ec2bdd2669e1f07.svg";
export { ForwardRef as ReactComponent };